import {ErrorBoundary} from '@github-ui/react-core/error-boundary'

export function HideOnError({children}: {children: React.ReactNode}) {
  return <ErrorBoundary fallback={null}>{children}</ErrorBoundary>
}

try{ HideOnError.displayName ||= 'HideOnError' } catch {}